<template>
    <Modal v-if="awardObj.showModalFlag === 'Y'" v-model="isVisibility" :mask-closable="false" :closable="false" :footer-hide="true" class-name="vertical-center-modal diyModal" height="320" width="320" :styles="{top: '100px'}"  >
        <div class="npsModalWrapper">
            <p class="title">恭喜获得优惠券</p>
            <p class="miniProgramReward">请进入微信小程序使用您的奖励</p>
            <div class="hiHonorImg">
                <img src="../../../../../../../static/runtime/images/magic/hiHonor.png" alt="">
            </div>
            <p class="QRCodeText">长按保存二维码至相册，然后打开微信扫码</p>
        </div>
        <div class="btn-tool align-center">
            <div style="width: 70%; margin-top: 20px;" class="modalBtn" @click="modalCancel(true)">确定</div>
        </div>
    </Modal>
    <Modal v-else v-model="isVisibility" :mask-closable="false" :closable="false" :footer-hide="true" class-name="vertical-center-modal diyModal" height="320" width="320" :styles="{top: '100px'}"  >
        <div class="npsModalWrapper">
            <p class="title">感谢您的反馈！</p>
            <!-- <p>优惠券已发放，请在微信打开【Hi荣耀】小程序，【我的】-【我的优惠券】页面查看。</p> -->
        </div>
        <div class="btn-tool align-center">
            <div style="width: 70%; margin-top: 20px;" class="modalBtn" @click="modalCancel(true)">确定</div>
        </div>
    </Modal>
</template>

<script>
export default {
    props: {
        awardObj: Object
    },
    data(){
        return{
            isVisibility: false,
        }
    },
    created() {
        console.log(this.awardObj)
    },
    mounted() {
       
    },
    computed: {
        
    },
    methods:{
        openModel(){
            this.isVisibility=true
        },
        modalOk(){
            self.isVisibility=false;   
        },
        modalCancel(flag){
            this.isVisibility=false;
        },
    },
}
</script>

<style>
    /* .npsModalWrapper {
        text-align: left;
        margin: 20px;
    }
    .npsModalWrapper .title {
        margin-bottom: 10px;
        font-size: 14px;
        color: #000;
    } */
    .npsModalWrapper {
        text-align: center;
        margin: 10px 10px;
    }
    .npsModalWrapper .title {
        margin-bottom: 10px;
        font-size: 16px;
        color: #000;
    }
    .npsModalWrapper .miniProgramReward {
        margin-bottom: 10px;
        font-size: 16px;
        color: #000;
    }
    .npsModalWrapper .hiHonorImg {
        /* background: url('../../../../../../../static/runtime/images/magic/hiHonor.png') no-repeat; */
        background-size: 100%;
        text-align: center;
    }
    .npsModalWrapper .hiHonorImg img{
        width: 120px !important;
        height: 120px;
        text-align: center;
    }
    .npsModalWrapper .QRCodeText {
        font-size: 12px;
        color: #ccc;
        margin-bottom: -10px;
    }
    .diyModal .ivu-modal {
        width: 75% !important;
        margin: auto;
    }
    .diyModal .ivu-modal-body {
        text-align: center;
        font-size: 14px;
    }
    .modalBtn {
        background-image: linear-gradient(102deg, #5196FE 0%, #2C71FE 81%);
        border-radius: 48px;
        border-radius: 48px;
        color: #fff;
        height: 36px;
        margin-top: 5px;
        line-height: 36px;
    }
</style>

 


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/NpsModal/submited-modal.vue